import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    SelectInput,
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import BoolNumField from '../controls/BoolNumField'
import LinkToCheckLists from './LinkToCheckLists'
import LinkToRecert from './LinkToRecert'



const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const QuickFilter = translate(
    withStyles(quickFilterStyles)(({ classes, label, translate }) => (
        <Chip className={classes.root} label={translate(label)} />
    ))
);

export const UserFilter = props => (
    <Filter {...props}>
        
        <TextInput source="full_name" alwaysOn label='Name'/>
        <SelectInput source="title" lable ='Title' allowEmpty emptyValue="" choices={[
            { id: 'Donor Processor', name: 'Donor Processor' },
            { id: 'General Manager', name: 'General Manager' },
            { id: 'Phlebotomy',     name: 'Phlebotomy' },
            { id: 'Physician Substitute',     name: 'Physician Substitute' },
            { id: 'Plasma Processor',     name: 'Plasma Processor' },
            { id: 'QA User', name: 'QA User' },
            { id: 'Site Manager', name: 'Site Manager' }
        ]} />
    </Filter>
);

export const Userslist = props => (
    <List 
        {...props}
        filters={<UserFilter />}
        perPage={20}
        sort={{ field: 'full_name', order: 'ASC' }}
        bulkActionButtons ={false}
        >
        <Datagrid    >
            <TextField source="full_name" label="Name" />
            <TextField source="title" label="Title"/>     
            <LinkToCheckLists  label="Checklist"/>
            <LinkToRecert      label="Recertify" />
        </Datagrid>
    </List>
);


export default Userslist